<template>
  <scroll-bar>
    <div class="logo-container">
      <img src="@/assets/logo.png" class="sidebar-logo" />
    </div>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#102f6e"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import ScrollBar from "@/components/ScrollBar";

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters(["sidebar", "routers"]),
    routes() {
      // return this.$router.options.routes
      return this.routers;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>
<style>
.logo-container {
  background: #102f6e;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-logo {
  width: 100%;
  height: 80px;
  padding: 10px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue